module.exports = __webpack_public_path__ + "static/media/18.eaebc33a.jpeg";